import SectionContact from './SectionContact'
import SectionFullWidthContent from './SectionFullWidthContent'
import SectionHero from './SectionHero'
import SectionImageList from './SectionImageList'
import SectionImageText from './SectionImageText'
import SectionList from './SectionList'
import SectionOffice from './SectionOffice'
import SectionPartners from './SectionPartners'
import SectionPrivacy from './SectionPrivacy'
import SectionSeparator from './SectionSeparator'
import SectionSlider from './SectionSlider'
import SectionTeaser from './SectionTeaser'
import SectionText from './SectionText'

export {
  SectionContact,
  SectionFullWidthContent,
  SectionHero,
  SectionImageList,
  SectionImageText,
  SectionList,
  SectionOffice,
  SectionPartners,
  SectionPrivacy,
  SectionSeparator,
  SectionSlider,
  SectionTeaser,
  SectionText
}
